module.exports = __webpack_public_path__ + "media/images/icons/flags/BO-c2e37d81e93b47616b93e3ec188a3134.svg";